export default __webpack_public_path__ + "static/p1_en-0af884280d2ce77af3b058f4cd12084b.png";